export const PRESENCE_OPTIONS = [
  { value: 'ONLINE', label: '線上' },
  { value: 'AWAY', label: '離開' },
  { value: 'BUSY', label: '忙碌' },
  { value: 'OFFLINE', label: '離線' },
];

export const SESSION_STATUS_LABEL = {
  WAITING: '等待中',
  ASSIGNED: '已指派',
  ACTIVE: '進行中',
  TRANSFERRING: '轉接中',
  REQUEUED: '重新排隊',
  ENDED: '已結束',
  ABANDONED: '已放棄',
};

export const LIST_TABS = {
  QUEUE: 'queue',
  MINE: 'mine',
  ENDED: 'ended',
};

export const SUPERVISOR_TABS = {
  QUEUE: 'queue',
  ENDED: 'ended',
  AUDIT: 'audit',
};

export const AUDIT_ACTION_LABEL = {
  SESSION_STARTED: '建立會話',
  SESSION_WAITING: '進入等待',
  ASSIGNMENT_CLAIM: '接手',
  ASSIGNMENT_ASSIGN: '指派',
  ASSIGNMENT_FORCE_ASSIGN: '強制指派',
  ASSIGNMENT_TRANSFER: '轉接接手',
  ASSIGNMENT_RELEASED: '釋放 Assignment',
  TRANSFER_PENDING: '轉接請求',
  TRANSFER_ACCEPTED: '轉接接受',
  TRANSFER_REJECTED: '轉接拒絕',
  TRANSFER_CANCELLED: '轉接取消',
  TRANSFER_EXPIRED: '轉接逾時',
  SOFT_ASSIGN_PENDING: 'Soft Assign 請求',
  SOFT_ASSIGN_ACCEPTED: 'Soft Assign 接受',
  SOFT_ASSIGN_REJECTED: 'Soft Assign 拒絕',
  SOFT_ASSIGN_CANCELLED: 'Soft Assign 取消',
  SOFT_ASSIGN_EXPIRED: 'Soft Assign 逾時',
  CS_WATCH_STARTED: '開始監看',
  CS_WATCH_ENDED: '結束監看',
  CS_FORCE_RELEASE: '強制釋放',
  CS_FORCE_TRANSFER: '強制轉接',
  CS_GRACE_DISCONNECT: '會員斷線 Grace',
  CS_GRACE_RESUMED: 'Grace 恢復',
  SESSION_ABANDONED: '放棄會話',
  SESSION_ENDED: '結束會話',
  PRESENCE_CHANGE: 'Presence 變更',
  CS_ACCESS_DENIED: '權限拒絕',
  ACCOUNT_DISABLED_OFFLINE: '帳號停用下線',
};

export function getCsConnectionId() {
  const key = 'im-cs-connection-id';
  let id = sessionStorage.getItem(key);
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID())
      || `cs-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    sessionStorage.setItem(key, id);
  }
  return id;
}

export function formatWaitSeconds(sec) {
  if (sec == null || Number.isNaN(Number(sec))) return '—';
  const n = Number(sec);
  if (n < 60) return `${n}s`;
  const m = Math.floor(n / 60);
  const s = n % 60;
  return `${m}m ${s}s`;
}

export function sessionTitle(item) {
  if (!item) return '—';
  if (item.customerDisplayName) return item.customerDisplayName;
  if (item.customerMemberId) return `會員 #${item.customerMemberId}`;
  if (item.sessionNo) return item.sessionNo;
  return `Session #${item.sessionId}`;
}
